import React from 'react'

type BackButtonProps = {
  onClick: () => void
  label?: string
  className?: string
}

export const BackButton = ({ onClick, label = 'Back', className = '' }: BackButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={`group inline-flex min-h-[44px] items-center gap-2.5 rounded-full border border-gray-200/90 bg-white px-2 py-1.5 pr-4 text-sm font-semibold text-graphite-grey shadow-sm ring-1 ring-black/[0.04] transition-all hover:border-aqua-mint/40 hover:text-royal-indigo hover:shadow-md focus:outline-none focus-visible:ring-2 focus-visible:ring-royal-indigo/30 active:scale-[0.99] sm:min-h-0 sm:px-2.5 sm:py-2 sm:pr-5 sm:text-[15px] ${className}`.trim()}
  >
    <span
      className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-slate-100 text-gray-600 transition-colors group-hover:bg-aqua-mint/15 group-hover:text-aqua-mint"
      aria-hidden
    >
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
    </span>
    {label}
  </button>
)
